import Container from '@/components/@base/container';

const AssetLoading = () => {
  return <Container className='flex flex-col w-full p-4'>
    <Container className='w-full h-16 relative bg-grayLight-40 dark:bg-grayDark-900'>
      <Container  className=' loading-asset'/>
    </Container>
    <Container className='w-full h-16 relative bg-grayLight-40 dark:bg-grayDark-900 mb-3 mt-3'>
      <Container  className=' loading-asset'/>
    </Container>
    <Container className='w-full h-16 relative bg-grayLight-40 dark:bg-grayDark-900 mb-3'>
      <Container  className=' loading-asset'/>
    </Container>
    <Container className='w-full h-16 relative bg-grayLight-40 dark:bg-grayDark-900'>
      <Container  className=' loading-asset'/>
    </Container>
  </Container>
}
export default AssetLoading